import { get, isString } from "lodash";

import styles from "./showFields.module.css";

function DateView({ value, displayValue }) {
  return (
    <time dateTime={value} className={styles.Date}>
      {get(displayValue, "displayValue") ||
        (isString(displayValue) && displayValue) ||
        value}
    </time>
  );
}

export default DateView;
